/**
 * @desc 回滚报关批次
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(id: string | number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/customsDeclarationMaster/rollBackBatch/${id}`, {
      method: "GET",

      ...options,
    }),
  );
}
